import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

export const setKeyword = keyword => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_KEYWORD,
    { keyword }
  )
)

export const setBufferedKeyword = keyword => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_BUFFERED_KEYWORD,
    { keyword }
  )
)

export const toggleDetailDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_DETAIL_DIALOG);